<template>
  <v-card>
    <v-card-text>
      <h3>Inductance</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Abhenry (abH)',
          val: 1
        },
        {
          text: 'Gigahenry (GH)',
          val: 1e-18
        },
        {
          text: 'Henry (H)',
          val: 1e-9
        },
        {
          text: 'Kilohenry (kH)',
          val: 1e-12
        },
        {
          text: 'Megahenry (MH)',
          val: 1e-15
        },
        {
          text: 'Microhenry (µH)',
          val: 0.001
        },
        {
          text: 'Millihenry (mH)',
          val: 0.000001
        },
        {
          text: 'Nanohenry (nH)',
          val: 1
        },
        {
          text: 'Weber per ampere (Wb/A)',
          val: 1e-9
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// inductance.vue?282acbd5